




















import { Component, Prop, Mixins } from "vue-property-decorator";
import { i18n } from "@/i18n";

import { WidgetMixin, EventMixin, LayoutMixin, Event } from "./mixins";

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue")
  }
})
export default class WModal extends Mixins(
  WidgetMixin,
  EventMixin,
  LayoutMixin
) {
  visible: boolean = false;

  @Prop({ type: String, default: "" })
  title!: string;

  @Prop({
    type: String,
    default: "md",
    validator: value => ["sm", "md", "lg"].includes(value)
  })
  size!: string;

  @Prop({ type: Boolean, default: false })
  shadow!: boolean;

  get computedTitle() {
    return i18n.t(this.title);
  }

  get computedClasses() {
    return {
      shadow: this.shadow
    };
  }

  @Event("show::modal")
  show() {
    this.visible = true;
  }

  @Event("hide::modal")
  hide() {
    this.visible = false;
  }
}
